import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function J_Other() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('outdoorrecreation');
    const { locale } = useRouter();
    // 本地化图片
    const LOCAL_SITES: string[] = ['za', 'kr'];
    return (
        <div id="outdoor-recreation-J" className={`outdoor-recreation-J ${css['outdoor-recreation-J']}`}>
            <div className="img-box">
                <EFPicture
                    src={`/responsive/picture/outdoor-recreation/9${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.jpg`}
                    srcDesktop={`/responsive/picture/outdoor-recreation/9_1366${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.jpg`}
                    srcPad={`/responsive/picture/outdoor-recreation/9_768${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.jpg`}
                    srcMobile={`/responsive/picture/outdoor-recreation/9_375${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.jpg`}
                    alt={t('secJ_title')}
                />
                <div className="text-content">
                    <p className="title">{t('secJ_title')}</p>
                    <p className="desc">{t('secJ_desc')}</p>
                    <div className="tags">
                        <span className="tag">{t('secJ_tag1')}</span>
                        <span className="tag">{t('secJ_tag2')}</span>
                        <span className="tag">{t('secJ_tag3')}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
